export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11319.0754f33f.jpg";